module.exports = __webpack_public_path__ + "media/assets/images/aws_connect/eccellenza-2f0b4f8546833c440ff5bb8214423206.png";